module.exports = __webpack_public_path__ + "Flama-LightItalic.woff2?82fd5d2b12697a3536cacf1208dcf7ce";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-LightItalic.woff2
// module id = 926
// module chunks = 0